import { render } from "./PortalFooter.vue?vue&type=template&id=3de3e063&scoped=true"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"

import "./PortalFooter.vue?vue&type=style&index=0&id=3de3e063&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de3e063"]])

export default __exports__